module.exports = __webpack_public_path__ + "8fedaa730ef4f98a1a29ba20c6e6a6a6.pdf";